import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useGetByDevice } from "./pages/use-gte-device";

const Layout = ({ children }) => {
  const location = useLocation();

  const getNavLinkClass = (path) => {
    return location.pathname === path
      ? "nav-item nav-link active"
      : "nav-item nav-link";
  };

  const isPageActive = (paths) => {
    return paths.some((path) => location.pathname === path);
  };

  const { isMobile } = useGetByDevice();

  return (
    <>
      {/* Spinner Start */}
      {/* <div
        id="spinner"
        className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
      >
        <div
          className="spinner-border text-secondary"
          style={{ width: "3rem", height: "3rem" }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div> */}
      {/* Spinner End */}

      {/* Topbar Start */}
      <div className="container-fluid bg-primary px-5 d-none d-lg-block">
        <div className="row gx-0 align-items-center">
          <div className="col-lg-5 text-center text-lg-start mb-lg-0">
            <div className="d-flex">
              <a href="#!" className="text-white me-4">
                <i className="fas fa-envelope text-secondary me-2"></i>
                butterflyairintl@gmail.com{" "}
              </a>
              <a href="#!" className="text-white me-0">
                <i className="fas fa-phone-alt text-secondary me-2"></i>
                +8801852966938, +8801950509000
              </a>
            </div>
          </div>
          <div className="col-lg-3 row-cols-1 text-center mb-2 mb-lg-0">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: "45px" }}
            >
              {/* <a
                className="btn btn-sm btn-outline-light btn-square rounded-circle me-2"
                href=""
              >
                <i className="fab fa-twitter fw-normal text-secondary"></i>
              </a> */}
              {/* <a
                className="btn btn-sm btn-outline-light btn-square rounded-circle me-2"
                href="https://www.facebook.com/share/1BXfiSfbk9/"
              >
                <i className="fab fa-facebook-f fw-normal text-secondary"></i>
              </a> */}
              {/* <a
                className="btn btn-sm btn-outline-light btn-square rounded-circle me-2"
                href=""
              >
                <i className="fab fa-linkedin-in fw-normal text-secondary"></i>
              </a> */}
              {/* <a
                className="btn btn-sm btn-outline-light btn-square rounded-circle me-2"
                href=""
              >
                <i className="fab fa-instagram fw-normal text-secondary"></i>
              </a>
              <a
                className="btn btn-sm btn-outline-light btn-square rounded-circle"
                href=""
              >
                <i className="fab fa-youtube fw-normal text-secondary"></i>
              </a> */}
            </div>
          </div>
          <div className="col-lg-4 text-center text-lg-end">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: "45px" }}
            >
              <a
                className="btn btn-sm btn-outline-light btn-square rounded-circle me-3"
                href="https://www.facebook.com/share/1BXfiSfbk9/"
              >
                <i className="fab fa-facebook-f fw-normal text-secondary "></i>
              </a>
              <NavLink to="/contact" className="text-white me-2">
                {" "}
                Help
              </NavLink>
              <small> / </small>
              <NavLink to="/contact" className="text-white mx-2">
                {" "}
                Support
              </NavLink>
              <small> / </small>
              <NavLink to="/contact" className="text-white ms-2">
                {" "}
                Contact
              </NavLink>
            </div>
          </div>
        </div>
      </div>
      {/* Topbar End */}

      {/* Navbar & Hero Start */}
      <div className="container-fluid nav-bar p-0">
        <nav className="navbar navbar-expand-lg navbar-light bg-white px-4 px-lg-5 py-3 py-lg-0">
          <a href="/" className="navbar-brand p-0">
            <img
              src="img/logo-cropped.svg"
              className="img-fluid w-100 h-100"
              alt="brand logo"
              style={{
                maxWidth: isMobile ? "125px" : "180px",
                maxHeight: "100%",
                padding: isMobile ? "0px" : "12px",
              }}
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
          >
            <span className="fa fa-bars"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto text-center py-0">
              <NavLink to="/" className={getNavLinkClass("/")}>
                Home
              </NavLink>
              <NavLink
                to="/visa-center"
                className={getNavLinkClass("/visa-center")}
              >
                Visa Center
              </NavLink>
              <NavLink to="/about" className={getNavLinkClass("/about")}>
                About
              </NavLink>
              <NavLink to="/service" className={getNavLinkClass("/service")}>
                Service
              </NavLink>
              <NavLink to="/gallery" className={getNavLinkClass("/gallery")}>
                Gallery
              </NavLink>
              {/* <div
                className={`nav-item dropdown ${
                  isPageActive([
                    "/feature",
                    "/countries",
                    "/testimonial",
                    "/training",
                    "/404",
                  ])
                    ? "active"
                    : ""
                }`}
              >
                <a
                  href="#"
                  className="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Pages
                </a>
                <div className="dropdown-menu m-0">
                  <NavLink
                    to="/feature"
                    className="dropdown-item"
                    activeClassName="active"
                  >
                    Feature
                  </NavLink>
                  <NavLink
                    to="/countries"
                    className="dropdown-item"
                    activeClassName="active"
                  >
                    Countries
                  </NavLink>
                  <NavLink
                    to="/testimonial"
                    className="dropdown-item"
                    activeClassName="active"
                  >
                    Testimonial
                  </NavLink>
                  <NavLink
                    to="/training"
                    className="dropdown-item"
                    activeClassName="active"
                  >
                    Training
                  </NavLink>
                  <NavLink
                    to="/404"
                    className="dropdown-item"
                    activeClassName="active"
                  >
                    404 Page
                  </NavLink>
                </div>
              </div> */}
              <NavLink to="/contact" className={getNavLinkClass("/contact")}>
                Contact
              </NavLink>
            </div>
            {/* <button
              className="btn btn-primary btn-md-square border-secondary mb-3 mb-md-3 mb-lg-0 me-3"
              data-bs-toggle="modal"
              data-bs-target="#searchModal"
            >
              <i className="fas fa-search"></i>
            </button>
            <a
              href=""
              className="btn btn-primary border-secondary rounded-pill py-2 px-4 px-lg-3 mb-3 mb-md-3 mb-lg-0"
            >
              Get A Quote
            </a> */}
          </div>
        </nav>
      </div>
      {/* Navbar & Hero End */}

      {children}

      {/* Footer Start */}
      <div
        className="container-fluid footer py-4 wow fadeIn"
        data-wow-delay="0.2s"
      >
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-6">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-secondary mb-4">Contact Info</h4>
                <a href="">
                  <i className="fa fa-map-marker-alt me-2"></i> Azad Center (3rd
                  Floor), 55, Purana Paltan, Dhaka-1000
                </a>
                <a href="">
                  <i className="fas fa-envelope me-2"></i>{" "}
                  butterflyairintl@gmail.com
                </a>
                <a href="">
                  <i className="fas fa-phone me-2"></i> +8801852966938,
                  +8801950509000
                </a>
                {/* <a href="" className="mb-3">
                  <i className="fas fa-print me-2"></i> +8801852966938,
                  +8801950509000
                </a> */}
                <div className="d-flex align-items-center">
                  <i className="fas fa-share fa-2x text-secondary me-2"></i>
                  <a className="btn mx-1" href="">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a className="btn mx-1" href="">
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a className="btn mx-1" href="">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a className="btn mx-1" href="">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-secondary mb-4">Opening Time</h4>
                <div className="mb-3">
                  <h6 className="text-muted mb-0">Saturday - Thursday:</h6>
                  <p className="text-white mb-0">10.00 am to 07.00 pm</p>
                </div>
                <div className="mb-3">
                  <h6 className="text-muted mb-0">Vacation:</h6>
                  <p className="text-white mb-0">All Friday is our vacation</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-secondary mb-4">Our Services</h4>
                <a href="#" className="">
                  <i className="fas fa-angle-right me-2"></i> Air Ticket
                </a>
                <a href="#" className="">
                  <i className="fas fa-angle-right me-2"></i> Tourist Visa
                </a>
                <a href="#" className="">
                  <i className="fas fa-angle-right me-2"></i> Work Visa
                </a>
                <a href="#" className="">
                  <i className="fas fa-angle-right me-2"></i> Students Visa
                </a>
                <a href="#" className="">
                  <i className="fas fa-angle-right me-2"></i> Business Visa
                </a>
                <a href="#" className="">
                  <i className="fas fa-angle-right me-2"></i> Residence Visa
                </a>
              </div>
            </div>
            {/* <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item">
                <h4 className="text-secondary mb-4">Newsletter</h4>
                <p className="text-white mb-3">
                  Dolor amet sit justo amet elitr clita ipsum elitr est.Lorem
                  ipsum dolor sit amet, consectetur adipiscing elit.
                </p>
                <div className="position-relative mx-auto rounded-pill">
                  <input
                    className="form-control border-0 rounded-pill w-100 py-3 ps-4 pe-5"
                    type="text"
                    placeholder="Enter your email"
                  />
                  <button
                    type="button"
                    className="btn btn-primary rounded-pill position-absolute top-0 end-0 py-2 mt-2 me-2"
                  >
                    SignUp
                  </button>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <div className="text-center text-md-center mb-md-0">
          <span className="text-white">
            <a href="#" className="border-bottom text-white">
              @Butterfly Air International
            </a>
            , All right reserved.
          </span>
        </div>
      </div>
      {/* Footer End */}

      {/* Back to Top */}
      <a href="#" className="btn btn-primary btn-lg-square back-to-top">
        <i className="fa fa-arrow-up"></i>
      </a>
    </>
  );
};

export default Layout;
